const context = require.context(
  "../../../../src/",
  true,
  /\/i18n\/en.json$/
);

export default context.keys().reduce((messages, path) => {
  return Object.assign(messages, context(path));
}, {});
